var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2.39999C6.7007 2.39999 2.3999 6.70079 2.3999 12C2.3999 17.2992 6.7007 21.6 11.9999 21.6C17.2991 21.6 21.5999 17.2992 21.5999 12C21.5999 6.70079 17.2991 2.39999 11.9999 2.39999ZM12.9599 18.72H11.0399V16.8H12.9599V18.72ZM14.9471 11.28L14.0831 12.1632C13.3919 12.864 12.9599 13.44 12.9599 14.88H11.0399V14.4C11.0399 13.344 11.4719 12.384 12.1631 11.6832L13.3535 10.4736C13.7087 10.128 13.9199 9.64799 13.9199 9.11999C13.9199 8.06399 13.0559 7.19999 11.9999 7.19999C10.9439 7.19999 10.0799 8.06399 10.0799 9.11999H8.1599C8.1599 6.99839 9.8783 5.27999 11.9999 5.27999C14.1215 5.27999 15.8399 6.99839 15.8399 9.11999C15.8399 9.96479 15.4943 10.7328 14.9471 11.28Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.00ab7c7f032f44e1219bde4626e90f98.svg";
export { ForwardRef as ReactComponent };